<template>
  <v-card outlined style="overflow: hidden; height: 600px" fluid fill-height class="ma-0 pa-0">
    <loading
      :can-cancel="cancelProg"
      :on-cancel="
        () => {
          isLoading = false;
        }
      "
      :background-color="$vuetify.theme.dark ? '#000' : '#FFF'"
      :color="$vuetify.theme.dark ? '#FFF' : '#000'"
      loader="bars"
      :active.sync="isLoading"
      :opacity="0.9"
    >
      <span slot="after">
        <br />
        {{ "Програмиране на клиент " + loaderValue + " от " + clientsCountMax }}
      </span>
    </loading>

    <v-container fluid class="ma-0 pa-0 customscroll" style="overflow-x: hidden">
      <v-row class="ma-0 pl-3 pb-1" justify="center" align="center">
        <v-spacer></v-spacer>
        <span class="title"><b>Програмиране на клиенти</b></span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="closeProgClients">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pa-0 mx-3 mt-3" justify="space-between">
        <v-text-field v-model="searchText" outlined label="Търсене" dense></v-text-field>

        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="addArticle">
          <v-icon color="#1685c9" left>mdi-plus</v-icon>
          <span>Добави</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="$refs.fileUpload.click()">
          <v-icon color="#1685c9" left>mdi-database-import</v-icon>
          <span>Импорт</span>
          <input type="file" accept=".txt" id="file" ref="fileUpload" v-on:change="importClients" style="display: none" />
        </v-btn>

        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="exportClients" :disabled="fp.articles.length == 0">
          <v-icon color="#1685c9" left>mdi-database-export</v-icon>
          <span>Експорт</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" :disabled="!selected.length > 0" @click="callProgClients">
          <v-icon color="#1685c9" left>mdi-content-save</v-icon>
          <span>Запази</span>
        </v-btn>
      </v-row>

      <v-card class="elevation-0 pa-0 ma-0">
        <v-form ref="progArticlesRef" v-on:submit.prevent lazy-validation>
          <v-virtual-scroll :items="searchPlu" :item-height="90" height="450" id="progVirtualScroll">
            <template v-slot="{ item }">
              <v-list-item :key="item.PLUNum">
                <v-row class="ma-0 pa-0" align="center" justify="center">
                  <v-col cols="1"><v-text-field :value="`${item.CustomerNum}`" label="№" dense outlined class="centered-input" disabled></v-text-field></v-col>
                  <v-col
                    ><v-text-field
                      @focus="$event.target.select()"
                      @input="
                        fixName(item);
                        shoveInForProgramming(item);
                      "
                      label="Фирма"
                      dense
                      outlined
                      v-model="item.CustomerCompanyName"
                      :rules="validCustomerCompanyName"
                  /></v-col>
                  <v-col
                    ><v-text-field
                      @focus="$event.target.select()"
                      @input="
                        fixName(item);
                        shoveInForProgramming(item);
                      "
                      label="Клиент"
                      dense
                      outlined
                      v-model="item.CustomerFullName"
                      :rules="validCustomerFullName"
                  /></v-col>
                  <v-col
                    ><v-text-field
                      @focus="$event.target.select()"
                      @input="
                        fixName(item);
                        shoveInForProgramming(item);
                      "
                      label="Адрес"
                      dense
                      outlined
                      v-model="item.Address"
                      :rules="validAddress"
                  /></v-col>
                  <v-col
                    ><v-text-field
                      @focus="$event.target.select()"
                      @input="
                        fixName(item);
                        shoveInForProgramming(item);
                      "
                      dense
                      outlined
                      class="ma-0 pa-0"
                      v-model="item.VATNumber"
                      label="ЗДДС номер"
                      :rules="validVAT_Num"
                    ></v-text-field
                  ></v-col>
                  <v-col><v-select @input="shoveInForProgramming(item)" class="ma-0 pa-0" dense outlined item-text="name" :items="optionUIC" v-model="item.OptionUICType" label="Тип на ЕИК"></v-select></v-col>
                  <v-col>
                    <v-text-field @focus="$event.target.select()" @input="shoveInForProgramming(item)" v-if="item.OptionUICType == 0" :rules="validEIK" dense outlined class="ma-0 pa-0" v-model="item.UIC" label="Булстат" required></v-text-field>
                    <v-text-field @focus="$event.target.select()" @input="shoveInForProgramming(item)" v-else-if="item.OptionUICType == 1" :rules="validEGN" dense outlined class="ma-0 pa-0" v-model="item.UIC" label="ЕГН" required></v-text-field>
                    <v-text-field @focus="$event.target.select()" @input="shoveInForProgramming(item)" v-else-if="item.OptionUICType == 2" :rules="validLNCH" dense outlined class="ma-0 pa-0" v-model="item.UIC" label="ЛНЧ" required></v-text-field>
                    <v-text-field @focus="$event.target.select()" @input="shoveInForProgramming(item)" v-else dense outlined class="ma-0 pa-0" :rules="required" v-model="item.UIC" label="Служебен номер" required></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-form>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import Const from "../constants.js";
import Tremol from "../assets/fp/fp";
import Loading from "vue-loading-overlay";
import Filesaver from "file-saver";
import iconv from "iconv-lite";
// import JSZip from "jszip";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      clients: [],
      cancelProg: false,
      searchText: "",
      isLoading: false,
      selected: [],
      loaderValue: 0,
      clientsCountMax: 0,
      optionUIC: [
        { name: "Булстат", value: Tremol.Enums.OptionUICType.Bulstat },
        { name: "ЕГН", value: Tremol.Enums.OptionUICType.EGN },
        { name: "ЛНЧ", value: Tremol.Enums.OptionUICType.Foreigner_Number },
        { name: "Служебен номер", value: Tremol.Enums.OptionUICType.NRA_Official_Number },
      ],
      egnChecksumDigits: ["2", "4", "8", "5", "10", "9", "7", "3", "6"],
      lnchChecksumDigits: ["21", "19", "17", "13", "11", "9", "7", "3", "1"],
      required: [(v) => !!v || "Задължително поле"],
      validCustomerCompanyName: [(v) => !!v || "Задължително поле", (v) => v.length <= 26 || "Името на фирмата не може да бъде повече от 26 символа"],
      validCustomerFullName: [(v) => !!v || "Задължително поле", (v) => v.length <= 16 || "Името на клиента не може да бъде повече от 16 символа"],
      validAddress: [(v) => !!v || "Задължително поле", (v) => v.length <= 30 || "Адресът не може да бъде повече от 30 символа"],
      validVAT_Num: [(v) => !!v || "Задължително поле", (v) => (v.length >= 9 && v.length <= 13) || "ЗДДС номерът трябва да бъде от 9 до 13 символа!"],
      validEIK: [(v) => !!v || "Задължително поле", (v) => !isNaN(v) || "Моля, въведете само цифри!", (v) => (v.length >= 9 && v.length <= 13) || "ЕИК/БУЛСТАТ трябва да бъде минимум 9 символа и не повече от 13", (v) => this.isValidEIK(v) || "Невалиден ЕИК/БУЛСТАТ"],
      validEGN: [(v) => !!v || "Задължително поле", (v) => v.length == 10 || "ЕГН трябва да бъде 10 символа", (v) => this.checkEGN(v) || "Невалиден ЕГН"],
      validLNCH: [(v) => !!v || "Задължително поле", (v) => v.length == 10 || "ЛНЧ трябва да бъде 10 символа", (v) => this.checkLNCH(v) || "Невалиден ЛНЧ"],
    };
  },

  computed: {
    searchPlu() {
      if (this.searchText == "") {
        return this.clients;
      } else {
        return this.clients.filter((article) => {
          return article.CustomerFullName.toLowerCase().includes(this.searchText.toLowerCase()) || article.CustomerCompanyName.toString().includes(this.searchText.toString().toLowerCase()) || article.UIC.toString().includes(this.searchText.toString().toLowerCase());
        });
      }
    },
  },
  methods: {
    addArticle() {
      try {
        let client = {
          CustomerCompanyName: "",
          CustomerFullName: "",
          Address: "",
          VATNumber: "",
          OptionUICType: "0",
          UIC: "",
        };
        if (this.clients.length == 0) {
          client.CustomerNum = 1;
        } else {
          let clientNum = Math.max.apply(
            Math,
            this.clients.map(function (client) {
              return parseInt(client.CustomerNum);
            })
          );
          client.CustomerNum = clientNum + 1;
        }

        this.clients.push(client);
        var progDiv = this.$el.querySelector("#progVirtualScroll");

        progDiv.scrollTop = progDiv.scrollHeight;
        this.$refs.progArticlesRef.validate();
      } catch (err) {
        this.fp.handleException(err);
      }
    },
    importClients() {
      try {
        let file = this.$refs.fileUpload.files[0];
        if (!file || file.type !== "text/plain") {
          throw new Error("Невалиден формат!");
        }
        this.selected = [];
        this.clients = [];
        let vm = this;
        let reader = new FileReader();
        reader.readAsText(file, "windows-1251");
        reader.onload = (evt) => {
          let res = evt.target.result.split("\n").slice(0, -1);
          res.forEach((plu) => {
            let p = plu.split("\t");
            if (p.length != 7) {
              throw new Error("Невалидно съдържание!");
            }

            if (p[1] != "" && p[6] != "") {
              let client = {
                CustomerNum: parseInt(p[0]),
                CustomerCompanyName: p[1].trim(),
                Address: p[2].trim(),
                VATNumber: p[3].trim(),
                OptionUICType: p[4],
                UIC: p[5],
                CustomerFullName: p[6].trim(),
              };
              console.log(client);
              vm.clients.push(client);
              vm.selected.push(client);
            }
          });
        };
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    exportClients() {
      if (this.$refs.progArticlesRef.validate()) {
        try {
          let forExport = [];

          this.clients.forEach((client) => {
            let article = client.CustomerNum + "\t" + client.CustomerCompanyName + "\t" + client.Address + "\t" + client.VATNumber + "\t" + client.OptionUICType + "\t" + client.UIC + "\t" + client.CustomerFullName.trim() + "\r\n";
            forExport.push(iconv.encode(article, "win1251"));
          });

          let blob = new Blob(forExport, { type: "text/plain; charset=windows-1251;" });
          Filesaver.saveAs(blob, "clients.txt");

          //   let zip = new JSZip();
          // zip.file("README.txt", "За да програмирате експортнатите артикули директно на фискалното устройство, можете да използвате един от двата метода: \n 1 - ECR Manager \n 2 - Импортиране директно във фискалното устройство чрез външна SD карта.");
          // zip.file("BCKP/articles.txt", blob);
          // zip.generateAsync({ type: "blob" }).then(function(content) {
          //   Filesaver.saveAs(content, "articles.zip");
          // });
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }
    },
    fixName(item) {
      if (item.CustomerCompanyName) if (item.CustomerCompanyName.indexOf("@") > -1) item.CustomerCompanyName = item.CustomerCompanyName.split("@").join(" ");
      if (item.CustomerFullName) if (item.CustomerFullName.indexOf("@") > -1) item.CustomerFullName = item.CustomerFullName.split("@").join(" ");
      if (item.Address) if (item.Address.indexOf("@") > -1) item.Address = item.Address.split("@").join(" ");
      if (item.VATNumber) if (item.VATNumber.indexOf("@") > -1) item.VATNumber = item.VATNumber.split("@").join(" ");
    },
    shoveInForProgramming(clnt) {
      if (this.selected.indexOf(clnt) == -1) {
        this.selected.push(clnt);
      }
    },
    async callProgClients() {
      try {
        if (this.$refs.progArticlesRef.validate()) {
          this.loaderValue = 0;
          this.isLoading = true;
          await this.ProgClients();
        } else {
          throw new Error("Намерен клиент с невалидни данни!");
        }
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    async ProgClients() {
      try {
        if (this.cancelProg) {
          this.loaderValue = 0;
          this.cancelProg = false;
          return;
        }
        let clientToProgram = this.selected[this.loaderValue];
        if (this.loaderValue >= this.selected.length) {
          this.selected.forEach((client) => {
            let found = this.fp.clients.find((clnt) => clnt.CustomerNum == client.CustomerNum);
            let index = this.fp.clients.indexOf(found);
            if (index != -1) {
              this.$set(this.fp.clients, index, client);
            } else {
              this.fp.clients.push(Object.assign({}, client));
            }
          });
          console.log(this.fp.clients);
          this.selected = [];
          this.loaderValue = 0;
          this.isLoading = false;
          this.fp.setInfoMessage("Успешно програмиране на клиенти.");
        } else {
          await this.fp.ProgCustomerData(clientToProgram.CustomerNum, clientToProgram.CustomerCompanyName, clientToProgram.CustomerFullName, clientToProgram.VATNumber, clientToProgram.UIC, clientToProgram.Address, clientToProgram.OptionUICType);
          this.loaderValue++;
          await this.ProgClients();
        }
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    checkLNCH(n) {
      try {
        let sum = 0;
        let checksum = 0;
        for (let i = 0; i < n.length - 1; i++) {
          sum = sum + this.lnchChecksumDigits[i] * n.charAt(i);
        }
        if (checksum % 10 == n.slice(-1)) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        this.fp.handleException(error);
      }
    },
    checkEGN(n) {
      try {
        let sum = 0;
        let checksum = 0;
        for (let i = 0; i < n.length - 1; i++) {
          sum = sum + this.egnChecksumDigits[i] * n.charAt(i);
        }
        if (sum % 11 == 0 || sum % 11 == 10) {
          checksum = 0;
        } else {
          checksum = sum % 11;
        }
        if (checksum == n.slice(-1)) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        this.fp.handleException(error);
      }
    },

    isValidEIK(v) {
      try {
        var matches;
        if (!(matches = v.match(/^(BG)?((\d{9})(\d{4})?)$/))) return false;

        //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
        var a = matches[3];
        var a9 = a[0] * 1 + a[1] * 2 + a[2] * 3 + a[3] * 4 + a[4] * 5 + a[5] * 6 + a[6] * 7 + a[7] * 8;
        a9 = a9 % 11;

        if (a9 == 10) {
          //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
          a9 = a[0] * 3 + a[1] * 4 + a[2] * 5 + a[3] * 6 + a[4] * 7 + a[5] * 8 + a[6] * 9 + a[7] * 10;
          a9 = a9 % 11;
        }

        a9 = a9 == 10 ? 0 : a9;

        if (a9 != a[8]) return false;
        if (!matches[4]) return true;

        //2*а9 + 7*а10 + 3*а11 +5*а12
        a = matches[4];
        var a13 = a9 * 2 + a[0] * 7 + a[1] * 3 + a[2] * 5;
        a13 = a13 % 11;

        //4*а9+9*а10+5*а11+7*а12
        if (a13 == 10) {
          a13 = a9 * 4 + a[0] * 9 + a[1] * 5 + a[2] * 7;
          a13 = a13 % 11;
        }

        a13 = a13 == 10 ? 0 : a13;
        return a13 == a[3];
      } catch (error) {
        this.fp.handleException;
      }
    },
    closeProgClients() {
      this.fp.exitMode(Const.Modes.ProgClients);
    },
    refreshClients() {
      this.clients = [];
      this.fp.clients.forEach((client) => {
        if (client.CustomerCompanyName != "" || client.CustomerFullName != "") {
          this.clients.push(Object.assign({}, client));
        }
      });
    },
  },
  mounted() {
    this.refreshClients();
  },
};
</script>

<style>
.v-select-list .v-list-item .v-list-item__content .v-list-item__title .v-select__selections {
  text-align: center;
}
</style>